<script>
import Layout from "@layouts/form";
import ContratoDespesaTipo from "@forms/ContratoDespesaTipo";

export default {
  page: {
    title: "Detalhes | Tipo de despesa de contrato"
  },
  components: { Layout, ContratoDespesaTipo },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Tipo de despesa de contrato",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Tipo de despesa de contrato",
          href: "/ContratoDespesaTipo"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ContratoDespesaTipo :editable="editable"></ContratoDespesaTipo>
    </div>
  </Layout>
</template>
